(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["devran-purchase"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', async function(event) {
 const form=event.target;
 if(!form.matches('.dv-purchase-form') || !window.fetch) return;
 event.preventDefault();
 if(form.dataset.pending==='true') return;
 const button=form.querySelector('[name="add"]');
 const error=form.querySelector('.dv-purchase-error');
 const body=new FormData(form);body.delete('return_to');
 form.dataset.pending='true';button.disabled=true;form.setAttribute('aria-busy','true');error.hidden=true;
 try {
  const response=await fetch(form.action.replace(/\/add\/?$/, '/add.js'),{method:'POST',body,headers:{Accept:'application/json'}});
  const result=await response.json();
  if(!response.ok) {error.textContent=typeof result.description==='string'?result.description:error.dataset.fallback;error.hidden=false;error.focus();return;}
  window.location.assign(form.querySelector('[name="return_to"]').value);
 } catch(e) {error.textContent=error.dataset.fallback;error.hidden=false;error.focus();}
 finally {form.dataset.pending='false';button.disabled=false;form.removeAttribute('aria-busy');}
});
  } catch(e) { console.error(e); }
})();

})();
